import { useState, useCallback } from 'react';
import { isNFCAvailable, readTag, writeTag } from '../services/nfcService';

function useNFC() {
  const [available] = useState(() => isNFCAvailable());
  const [scanning, setScanning] = useState(false);
  const [writing, setWriting] = useState(false);
  const [error, setError] = useState(null);

  const scan = useCallback(async () => {
    setError(null);
    setScanning(true);
    try {
      const position = await readTag();
      return position;
    } catch (err) {
      setError(err.message || 'Failed to scan NFC tag');
      return null;
    } finally {
      setScanning(false);
    }
  }, []);

  const write = useCallback(async (row, col) => {
    setError(null);
    setWriting(true);
    try {
      await writeTag(row, col);
    } catch (err) {
      setError(err.message || 'Failed to write NFC tag');
    } finally {
      setWriting(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return { available, scanning, writing, error, scan, write, clearError };
}

export default useNFC;
